export default {
  namespaced: true,

  state: {
    globalPlayer: null,
    isNativePlayer: false
  },

  mutations: {
    setGlobalPlayer(state, player) {
      state.globalPlayer = player
    },

    setIsNativePlayer(state, isNativePlayer) {
      state.isNativePlayer = isNativePlayer
    }
  },

  actions: {
    async setupGlobalPlayer({ state, commit }) {
      if (state.globalPlayer) return

      const { default: AudioPlayer } = await import("@/lib/audio/audio-player")

      commit(
        "setGlobalPlayer",
        new AudioPlayer({ native: state.isNativePlayer })
      )
    }
  },

  getters: {
    globalPlayer(state) {
      return state.globalPlayer
    }
  }
}
